import classNames from "classnames";
import { useEffect } from "react";
import { ModalClose } from "@/public/icons/ModalClose";
import styles from "./Modal.module.scss";

type ModalStyles = {
  modal?: string;
  close?: string;
  title?: string;
};

type ModalProps = {
  isOpen: boolean;
  setIsOpen: (isOpened: boolean) => void;
  title: string;
  overrideStyles?: ModalStyles;
  children: React.ReactNode;
  onClose?: () => void;
};

export const Modal = ({
  isOpen,
  setIsOpen,
  onClose,
  title,
  overrideStyles,
  children,
}: ModalProps) => {
  function closeModale() {
    setIsOpen(false);
    if (onClose) {
      onClose();
    }
  }

  // Locking the scroll
  useEffect(() => {
    document.body.style.overflowY = isOpen ? "hidden" : "scroll";

    return () => {
      document.body.style.overflowY = "scroll";
    };
  }, [isOpen]);

  return (
    <div
      className={classNames(styles.modalContainer, {
        [styles.opened]: isOpen,
      })}
    >
      <div className={styles.backdrop} onClick={() => closeModale()} />
      <div className={classNames(styles.modal, overrideStyles?.modal)}>
        <button
          className={classNames(styles.modalClose, overrideStyles?.close)}
          onClick={closeModale}
        >
          <ModalClose color="#062E5E" width="50" height="50" />
        </button>
        <div className={classNames(styles.modalTitle, overrideStyles?.title)}>
          {title}
        </div>
        <div className={styles.modalBody}>{children}</div>
      </div>
    </div>
  );
};
